import { FC } from "react";
import { ICancellationStats } from "../../../models/statistcs/respons";
import CancellationStatsCard from "../cancellation-stats-card";

interface IProps {
  stats?: ICancellationStats;
  onChange: (stats: ICancellationStats) => void;
  hideDateControls?: boolean;
}

const CustomerCancellationStats: FC<IProps> = ({
  stats,
  onChange,
  hideDateControls,
}) => (
  <CancellationStatsCard
    stats={stats}
    onChange={onChange}
    hideDateControls={hideDateControls}
    titleKey="customer_cancellation_stats"
    cancelledField="customerCancelledCount"
    cancelledLabelKey="customer_cancelled_orders"
    averageLabelKey="average_customer_cancellation_time"
  />
);

export default CustomerCancellationStats;
